// Copyright (c) 2016 Deere & Company

import {isNotEmpty, isNotNull} from '../../../shared/services/claim-shared-helper';

export const canGetMaintenancePlans = claim => [
    isNotEmpty(claim.pin),
    isNotNull(claim.serviceDate),
    isNotEmpty(claim.useAmount.amount),
    isNotEmpty(claim.useAmount.unit.key)
].every(rule => rule);

export const mapFormValidation = (property, value) => {

    const map = {
        comments: isNotEmpty,
        machineType: isNotEmpty,
        pin: isNotEmpty,
        planName: isNotEmpty,
        referenceNumber1: isNotEmpty,
        responsibleAccount: isNotEmpty,
        serviceDate: isNotNull,
        serviceInterval: isNotEmpty,
        useAmount: isNotEmpty,
        useAmountUnit: isNotEmpty
    };

    return map[property](value);

};



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/services/claim-validation-helper.js